export default __webpack_public_path__ + "static/media/Waterfall2.fea81ba1.jpg";